import styled from '../../theme'
import { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

export const IntegrationWrapper = styled.div<IWithSize>`
  display: flex;
  width: 100%;
  align-items: center;
  padding-top: ${({ size }) => (size ? 5 * size : 5)}px;
  padding-bottom: ${({ size }) => (size ? 5 * size : 5)}px;
  margin-right: ${({ size }) => (size ? 27 * size : 27)}px;

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    margin-right: ${({ size }) => (size ? 15 * size : 15)}px;
  }
`
